import { window } from './facade/browser';

export function isBs3(): boolean {
  return window.__theme === 'bs4';
}



// WEBPACK FOOTER //
// C:/Users/bompadre/Documents/angular2/myapp2/node_modules/angular-bootstrap-md/utils/ng2-bootstrap-config.ts